import React, { useEffect, useRef } from 'react';

import { QuickFindStoreContainer, useQuickFindActions } from '../index';

const RovoJourneyIdUrlSync = ({
	incomingRovoJourneyId,
}: {
	incomingRovoJourneyId?: string;
}): null => {
	const { setRovoJourneyId } = useQuickFindActions();
	const previousIncomingRovoJourneyId = useRef(incomingRovoJourneyId);

	useEffect(() => {
		if (incomingRovoJourneyId && incomingRovoJourneyId !== previousIncomingRovoJourneyId.current) {
			setRovoJourneyId(incomingRovoJourneyId);
		}
		previousIncomingRovoJourneyId.current = incomingRovoJourneyId;
	}, [incomingRovoJourneyId, setRovoJourneyId]);

	return null;
};

export const QuickFindStoreProvider = ({
	children,
	initialRovoJourneyId,
	shouldContinueRovoJourneyId = false,
	shouldStartRovoJourneyId = false,
}: {
	children: React.ReactNode;
	initialRovoJourneyId?: string;
	shouldContinueRovoJourneyId?: boolean;
	shouldStartRovoJourneyId?: boolean;
}): React.JSX.Element => {
	const scopedInitialRovoJourneyId = shouldContinueRovoJourneyId ? initialRovoJourneyId : undefined;

	return (
		<QuickFindStoreContainer
			initialRovoJourneyId={scopedInitialRovoJourneyId}
			shouldStartRovoJourneyId={shouldStartRovoJourneyId}
		>
			<RovoJourneyIdUrlSync incomingRovoJourneyId={scopedInitialRovoJourneyId} />
			{children}
		</QuickFindStoreContainer>
	);
};
